/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Auth } from 'aws-amplify';
import { useQueryUserInfo } from '../../hooks';

const ValidateUser = () => {
  const { userData, isFetching, error } = useQueryUserInfo();

  const signOut = async () => {
    await Auth.signOut();
    window.location.reload();
  };

  if (((userData && Object.keys(userData).length === 0) || !userData) && !isFetching && !error) {
    signOut();
  }

  return <></>;
};

export default ValidateUser;
